module.exports = __webpack_public_path__ + "static/media/iconCantine.2b910eb5.svg";